<mat-card class="mat-elevation-z2 uv-index-card" >
  <mat-card-header>
    <mat-card-title>{{uv.ort.name}}</mat-card-title>
    <!--      <mat-card-subtitle-->
    <!--        style="text-align: left">{{uv?.forecastDay?.toDate() | date:'EEE dd.MM':'UTC'}}</mat-card-subtitle>-->
  </mat-card-header>
  <mat-card-content>
    <ng-container *ngFor="let tag of uv.vorhersagen.tagesListe">
        <span class="uv-index-card-content-title">{{tag?.datum| date: 'EEE dd.MM':'UTC'}}
          - Gefährdungsgrad: <b>{{tag.uvIndex}}</b></span>
      <div class="uv-index-card-content">
        <table>
          <tr>
            <th *ngFor="let hauttype of tag.skintypesMaxExposureDurations.hautTypListe">{{hauttype.name}}</th>
          </tr>
          <tr>
            <td *ngFor="let hauttype of tag.skintypesMaxExposureDurations.hautTypListe">
              Max. {{hauttype.maxMinutes}} Min.
            </td>
          </tr>
        </table>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
